import * as linkConst from '../../constants/link_constants'
import * as defaultConst from '../../constants/default_constants'
import { BaseManipStateFn, BaseTableState } from './base'

export default (store) => {
  class ManipState extends BaseManipStateFn(store) {
    prepareNew () {
      this.record.set('year', new Date().getUTCFullYear())
      this.record.set('month', new Date().getUTCMonth())
    }

    onSaved (saved) {
      super.onSaved(saved)
    }

    requiredOptions = [
      'ContractCurrency',
      'Platforms',
      linkConst.LOAD_OPTIONS.contracts,
      linkConst.LOAD_OPTIONS.xrates
    ]

    createtitle = store.__(linkConst.LINK_XRATES_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_CREATE)
    edittitle = store.__(linkConst.LINK_XRATES_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_EDIT)
    validators = {
      currency_from: (val) => {
        if (!val || val.length === 0) {
          return store.__('this is mandatory')
        }
      },
      currency_to: (val) => {
        if (!val || val.length === 0) {
          return store.__('this is mandatory')
        }
      },
      platform: (val) => {
        if (!val || val.length === 0) {
          return store.__('this is mandatory')
        }
      },
      year: (val) => {
        if (!val || val.length === 0) {
          return store.__('this is mandatory')
        }

        if (val > 2999 || val < 2000) {
          return store.__('Year must be at least in this milenium')
        }
      },
      month: (val) => {
        if (!val || val.length === 0) {
          return store.__('this is mandatory')
        }

        if (val > 12) {
          return store.__('Year have only 12 months')
        }

        if (val <= 0) {
          return store.__('Year can not have zero or negative amout of months')
        }
      },
      exchange_rate: (val) => {
        if (!val || val.length === 0) {
          return store.__('this is mandatory')
        }
      },
      _global: (vals) => {
        if (!!vals.get('currency_from') && !!vals.get('currency_to')) {
          if (vals.get('currency_from') === vals.get('currency_to')) {
            return [store.__(`Convert between ${vals.get('currency_from')} and  ${vals.get('currency_to')} is unnecessary`)]
          }

          for (const x of store.options.get('xrates')) {
            if ((x.currency_from == vals.get('currency_from') &&
                x.currency_to == vals.get('currency_to') &&
                x.platform == vals.get('platform') &&
                x.exchange_rate == vals.get('exchange_rate') &&
                x.year == vals.get('year') &&
                x.month == vals.get('month') &&
                x.contract_id == vals.get('contract_id')) &&
                x.id != vals.get('id')) {
              return [store.__('Exchange rate must be unique, this one is already inserted.')]
            }
          }
        }
      }
    }
  }

  class TableState extends BaseTableState {
    attrs = [
      'id',
      'contract_id',
      'platform',
      'currency_from',
      'currency_to',
      'exchange_rate',
      'month',
      'year'
    ]

    headertitles = [
      store.__('ID'),
      store.__('contract'),
      store.__('platform'),
      store.__('from'),
      store.__('to'),
      store.__('rate'),
      store.__('month'),
      store.__('year')
    ]

    title = store.__(linkConst.LINK_XRATES_TITLE)
    defaultSort = linkConst.DEFAULT_SORT[linkConst.LINK_XRATES]

    requiredOptions = [
      'ContractCurrency',
      'Platforms',
      linkConst.LOAD_OPTIONS.contracts,
      linkConst.LOAD_OPTIONS.reports
    ]

    init () {
      return super.init()
    }
  }

  return { ManipState, TableState }
}
